import Axios from 'axios';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import { basicManager, publisherManager } from '../helpers/managers';
import { sendSimpleWelcomeEmail } from '../helpers/sendEmails';
const { accessExpirationWithGracePeriod, isStaging } = require('../../server/scripts/utils')();

const handleChargeState = (userInfo, chargeState, publisherName) => {
  return new Promise(async (resolve, reject) => {
    try {
      const creatorID = userInfo.id;
      let publisherID = userInfo.publisherID;
      const email = userInfo.email[0];

      // #701 new publishers since 09/24/2020 will be considered as class 2
      // that includes existing users that upgrades to the new plan class
      // old publishers stays at class 1. For plan tier updates
      const publisherClass = 2;
      const commonMetadata = {
        email,
        owner: creatorID,
        class: publisherClass,
        created: moment().unix(),
        transition: {
          episodes: 'done',
        },
      };

      if (!publisherID) {
        if (!publisherName) {
          console.error(
            `ERROR: Charge handler - publisherName must be provided`,
            JSON.stringify(userInfo)
          );
          return reject(new Error(`Publisher name must be provided`));
        }

        // create new publisher
        publisherID = moment().format('x') + 'p';
        const nameEncoded = encodeURIComponent(publisherName);
        const imageUrl = `https://dummyimage.com/300.png/F76B1C/ffffff&text=${nameEncoded}`;
        const _newPublisher = {
          id: publisherID,
          name: publisherName,
          imageUrl,
          administrators: { [creatorID]: true },
          ...commonMetadata,
        };

        console.log('_newPublisher', _newPublisher);

        const publisherSoundcasts = await publisherManager.getProp(publisherID, 'soundcasts');

        await basicManager.update({
          [`publishers/${publisherID}`]: _newPublisher,
          [`users/${creatorID}/id`]: creatorID,
          [`users/${creatorID}/soundcasts_managed`]: publisherSoundcasts,
          [`users/${creatorID}/admin`]: true,
          [`users/${creatorID}/publisherID`]: publisherID,
          [`users/${creatorID}/withTour`]: true, // tours should only for publishers for now
        });

        await new Promise(resolve => {
          const currentDate = moment().utc().format();
          // console.log('success add publisher: ', res);
          Axios.post('/api/publishers', {
            publisherId: publisherID,
            name: publisherName,
            imageUrl,
            ...commonMetadata,
            createdAt: currentDate,
            updatedAt: currentDate,
          })
            .then(res => {
              console.log('handleChargeState publisher added to db');
              resolve();
            })
            .catch(err => {
              console.error(`handleChargeState publisher wasn't added to db`, err);
              resolve();
            });
        });

        await preparingDemoSoundcast(publisherID);

        // send welcome email to publisher
        const { firstName, lastName } = userInfo;
        sendSimpleWelcomeEmail({ firstName, lastName, email });
      } else {
        // update existing publishers metadata
        await Axios.patch(`/api/publishers/${publisherID}`, { ...commonMetadata });
      }

      const { plan, frequency, promoCode, trialPeriod, chargeData } = chargeState;
      const accessExpiration = accessExpirationWithGracePeriod(chargeData.current_period_end);
      const multiUpdates = {
        [`publishers/${publisherID}/plan`]: plan,
        [`publishers/${publisherID}/frequency`]: frequency,
        [`publishers/${publisherID}/current_period_end`]: accessExpiration,
        [`publishers/${publisherID}/auto_renewal`]: trialPeriod ? false : true,
        [`publishers/${publisherID}/subscriptionID`]: chargeData.id,
        [`publishers/${publisherID}/stripe_customer_id`]: chargeData.customer,
        [`users/${creatorID}/stripe_id`]: chargeData.customer,
      };

      // include common metadata
      if (!isEmpty(commonMetadata)) {
        Object.keys(commonMetadata).forEach(propkey => {
          const value = commonMetadata[propkey];
          multiUpdates[`publishers/${publisherID}/${propkey}`] = value;
        });
      }

      // set trial period end
      if (trialPeriod) {
        multiUpdates[`publishers/${publisherID}/trialEnd`] = moment()
          .add(trialPeriod, 'days')
          .format('X');
      }

      // set promo code used
      if (promoCode && !trialPeriod) {
        multiUpdates[`publishers/${publisherID}/coupon`] = {
          code: promoCode,
          expires_on: accessExpiration,
        };
      }

      console.log('multiUpdates', multiUpdates);

      // multi update
      await basicManager.update(multiUpdates);

      // update subscription data here
      await Axios.post('/api/update_subscription', {
        userId: creatorID,
        publisherID,
        subscriptionID: chargeData.id,
        customerID: chargeData.customer,
      });

      resolve();
    } catch (err) {
      console.error(`ERROR: Charge handler`, err.message, JSON.stringify(userInfo));
      reject(err);
    }
  });
};

const preparingDemoSoundcast = async (publisherId) => {
  let errorMessage = null;
  try {
    await Axios.post('/api/replicate_soundcast', {
      publisherId,
      soundcastId: isStaging()
        ? '1602513767720s'  // staging, 1602430618771p, "soundcast test 2"
        : '1617152085428s', // productions, 1607288451996p, "Demo Soundcast test pricing"
      demo: true,
    });
  } catch (error) {
    errorMessage = error.message;
  }
  return errorMessage;
};

export { handleChargeState, preparingDemoSoundcast };
